import {createI18n} from 'vue-i18n';
import enMessages from '../../lang/en.json';
import deMessages from '../../lang/DE.json';

const initialLocale = String(document.documentElement.lang || 'en').trim().toLowerCase() || 'en';

const i18n = createI18n({
    legacy: true,
    globalInjection: true,
    locale: initialLocale,
    fallbackLocale: 'en',
    messages: {
        en: enMessages,
        de: deMessages,
    },
    missingWarn: false,
    fallbackWarn: false,
});

export default i18n;
